export function serverReducer(state, action) {
  switch (action.type) {
    case "SET_CURRENT_PID":
      return {
        ...state,
        pid: action.payload,
      };
    case "SET_PRODUCT_PRICE":
      return {
        ...state,
        price: action.payload,
      };
    case "SET_PRODUCT_DETAIL":
      return {
        ...state,
        serverDetails: {
          ...state.serverDetails,
          gid: action.payload.gid,
          pid: action.payload.pid,
          name: action.payload.name,
          type: action.payload.type,
          price: action.payload.price,
          billingcycle: action.payload.billingcycle,
          serveraddons: [],
        },
      };
    case "SET_PROMO":
      return {
        ...state,
        promo: {
          ...state.promo,
          realprice: action.payload.realprice,
          appliesto: action.payload.appliesto,
          description: action.payload.description,
          price: action.payload.price,
          type: action.payload.type,
          promocode: action.payload.promocode,
          pid: action.payload.pid,
        },
      };
    case "SET_HOSTNAME_PASSWORD":
      return {
        ...state,
        serverDetails: {
          ...state.serverDetails,
          hostname: action.payload.hostname,
          password: action.payload.password,
        },
      };
    case "SET_OS":
      return {
        ...state,
        serverDetails: {
          ...state.serverDetails,
          serveraddons: [action.payload.os],
        },
      };
    case "SET_PRICE_WITH_ADDON":
      return {
        ...state,
        serverDetails: {
          ...state.serverDetails,
          priceWithAddon: action.payload,
        },
      };
    default:
      return state;
  }
}